<template>
  <div class="login-box">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.13/css/all.css" />
    <div class="login-logo">
      <a href="#">
        <b class="text-warning">FX</b>hanuman
      </a>
    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg">Login</p>

        <form @submit.prevent="onSubmit()">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              name="email"
              v-validate="'required|email'"
              v-model.trim="form.email"
              :class="{ 'is-invalid': errors.has('email') }"
              placeholder="Email"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
            <span class="invalid-feedback">{{ errors.first('email') }}</span>
          </div>

          <div class="input-group mb-3">
            <input
              type="password"
              class="form-control"
              name="password"
              v-validate="'required'"
              v-model.trim="form.password"
              :class="{ 'is-invalid': errors.has('password') }"
              placeholder="Password"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-lock"></span>
              </div>
            </div>
            <span class="invalid-feedback">{{ errors.first('password') }}</span>
          </div>
          <div class="row">
            <div class="col-12">
              <button type="submit" class="btn bg-gradient-success btn-block text-white">Login</button>
              <b-link href="/register" class="btn bg-gradient-warning btn-block text-white">Register</b-link>
              <b-link href="#" class="btn bg-gradient-danger btn-block text-white">Forgot Password</b-link>
            </div>
            <!-- /.col -->
          </div>
        </form>
      </div>
      <!-- /.login-card-body -->
    </div>
  </div>
  <!-- /.login-box -->
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      errorMessage: ""
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        axios
          .post("backend/login", this.form)
          .then(response => {
            console.log(response.data);
            if (response.data.status == "S") {
              this.$Progress.start();
              this.$swal.fire(
                "Login Success!",
                "เข้าสู่ระบบเรียบร้อยแล้ว",
                "success"
              );
              this.$router.push({ path: "download" });
              this.$Progress.finish();
            } else {
              this.$Progress.start();
              this.$swal.fire(
                "Login Error!",
                "Email หรือ Password ไม่ถูกต้อง",
                "error"
              );
              this.$Progress.fail();
            }
          })
          .catch(err => (this.errorMessage = err.response.data.message));
      });
    }
  }
};
</script>

<style scoped>
.login-box-msg {
  font-size: 20px;
  font-weight: bold;
}

.text-warning {
  font-size: 60px;
}
</style>